import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState, useRef} from "react";
import Button from "react-bootstrap/Button";
import {DateBox, NumberBox, TextArea, TextBox, ValidationGroup, SelectBox} from "devextreme-react";
import {alert} from "devextreme/ui/dialog";
import apiClient from "../../../services/axios";
import cl from "../../../RetroAssets.System/Utilities";
import Validator, {RequiredRule} from "devextreme-react/validator";
import LoaderService from "../../../RetroAssets.System/LoaderService";
import RetroFormItem from "../../../RetroAssets.System/FormGroup";

function ManageOwnerVendorAgentDetails(props) {
    const {show, externalId, owner, vendor, agent, externalBanks} = props
    const [showModal, setShowModal] = useState(false);

    const validationGroup = useRef(null);
    const [details, setDetails] = useState({})
    const [allCountries, setAllCountries] = useState([])
    const modalClose = () => {
        setDetails({})
        props.handleClose()
        setDetails({})
        setShowModal(false);
    }

    useEffect(() => {
        if (!show) return
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalId: externalId
        })
        apiClient
            .get('/Configuration/GetDetailsForManageAccount?' + params)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    let dt = data[0]["Details"]["Data"]
                    if (externalId) {
                        dt["Country"] = cl.getEcoIdFromExternalId(dt["Country"])
                    } else {
                        if (owner)
                            dt["Flag_Capital"] = true
                        else if (vendor)
                            dt["Flag_Vendor"] = true
                        else if (agent)
                            dt["Flag_Agent"] = true
                    }
                    setDetails(dt)
                    setAllCountries(data[1]["Countries"])
                    setShowModal(true)
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }, [show])

    const valueChangeHandler = e => {
        if (!e.event) return
        let prop = e.component.option("property")
        setDetails({
            ...details,
            [prop]: e.value
        })
    }

    const saveData = () => {
        if (!validationGroup.current.instance()?.validate().isValid) {
            return
        }
        LoaderService.setData(true)
        let formData = new FormData();
        formData.append("Data", JSON.stringify(details));
        formData.append("SpanString", "_AccountDetails")
        apiClient
            .post('/Configuration/AddUpdateAccount', formData)
            .then(response => {
                if (response) {
                    try {
                        LoaderService.setData(false)
                        let resp = JSON.parse(response.data)
                        modalClose()
                        if (resp[0].response) {
                            props.isUpdated()
                        } else {
                            return alert(resp[0].message, 'Warning!')
                        }
                    } catch (e) {
                        LoaderService.setData(false)
                        return alert(response.data, 'Error!')
                    }
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    return (<Modal show={showModal} onHide={modalClose} centered dialogClassName="modal-70w prop-img-slider"
                   backdrop="static" keyboard={false}>
        <Modal.Header closeButton className="border-0 pb-0 modal-header">
            <Modal.Title className="fs-5 fw-bold">
                <span>{vendor ? "MANAGE VENDOR DETAILS" : agent ? "MANAGE AGENT DETAILS" : "MANAGE OWNER DETAILS"}</span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
            <div className="py-2 tabs-border" id="ManageTransaction_DetailsTab">
                <div className="row tabsContent">
                    <ValidationGroup ref={validationGroup}>
                        <div className="col-sm-12">
                            <div className="row">
                                {/*Name*/}
                                <div className="col-sm-12 col-md-12">
                                    <RetroFormItem
                                        label={"Name"}
                                        mandatory={true}
                                        valueField={
                                            <TextBox
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "input-group"}}
                                                placeholder="Name"
                                                property={"Name"}
                                                value={details["Name"]}
                                                onValueChanged={valueChangeHandler}
                                            >
                                                <Validator>
                                                    <RequiredRule message={"Name cannot be empty."}></RequiredRule>
                                                </Validator>
                                            </TextBox>}
                                    ></RetroFormItem>
                                </div>
                            </div>
                            {/*Address, City, Pincode, Country, Website*/}
                            <div className="row">
                                {/*Address*/}
                                <div className="col-sm-12 col-md-4">
                                    <RetroFormItem
                                        label={"Address"}
                                        mandatory={false}
                                        valueField={
                                            <TextArea
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "input-group"}}
                                                placeholder="Address"
                                                height={100}
                                                property={"Address"}
                                                value={details["Address"]}
                                                onValueChanged={valueChangeHandler}
                                            />}
                                    ></RetroFormItem>
                                </div>
                                {/*City, PinCode,*/}
                                <div className="col-sm-12 col-md-4">
                                    <div className="row">
                                        {/*City*/}
                                        <div className="col-sm-12">
                                            <RetroFormItem
                                                label={"City"}
                                                mandatory={false}
                                                valueField={
                                                    <TextBox
                                                        inputAttr={{class: "form-control"}}
                                                        elementAttr={{class: "input-group"}}
                                                        placeholder="City"
                                                        property={"City"}
                                                        value={details["City"]}
                                                        onValueChanged={valueChangeHandler}
                                                    />}
                                            ></RetroFormItem>
                                        </div>
                                        {/*Pincode*/}
                                        <div className="col-sm-12">
                                            <RetroFormItem
                                                label={"PIN Code"}
                                                mandatory={false}
                                                valueField={
                                                    <TextBox
                                                        inputAttr={{class: "form-control"}}
                                                        elementAttr={{class: "input-group"}}
                                                        placeholder="PIN Code"
                                                        property={"PinCode"}
                                                        value={details["PinCode"]}
                                                        onValueChanged={valueChangeHandler}
                                                    />}
                                            ></RetroFormItem>
                                        </div>
                                    </div>
                                </div>
                                {/*Country, Website,*/}
                                <div className="col-sm-12 col-md-4">
                                    <div className="row">
                                        {/*Country*/}
                                        <div className="col-sm-12">
                                            <RetroFormItem
                                                label={"Country"}
                                                mandatory={false}
                                                valueField={
                                                    <SelectBox
                                                        dataSource={allCountries}
                                                        displayExpr={"Name"}
                                                        valueExpr={"externalId"}
                                                        inputAttr={{class: "form-control"}}
                                                        elementAttr={{class: "input-group"}}
                                                        placeholder="Country"
                                                        property={"Country"}
                                                        value={details["Country"]}
                                                        onValueChanged={valueChangeHandler}
                                                    />}
                                            ></RetroFormItem>
                                        </div>
                                        {/*Website*/}
                                        <div className="col-sm-12">
                                            <RetroFormItem
                                                label={"Website"}
                                                mandatory={false}
                                                valueField={
                                                    <TextBox
                                                        inputAttr={{class: "form-control"}}
                                                        elementAttr={{class: "input-group"}}
                                                        placeholder="Website"
                                                        property={"Website"}
                                                        value={details["Website"]}
                                                        onValueChanged={valueChangeHandler}
                                                    />}
                                            ></RetroFormItem>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*Cellphone, Telephone, Email*/}
                            <div className="row">
                                {/*Cellphone*/}
                                <div className="col-sm-12 col-md-4">
                                    <RetroFormItem
                                        label={"Cellphone"}
                                        mandatory={false}
                                        valueField={
                                            <TextBox
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "input-group"}}
                                                placeholder="Cellphone"
                                                property={"Cellphone"}
                                                value={details["Cellphone"]}
                                                onValueChanged={valueChangeHandler}
                                            />}
                                    ></RetroFormItem>
                                </div>
                                {/*Telephone*/}
                                <div className="col-sm-12 col-md-4">
                                    <RetroFormItem
                                        label={"Telephone"}
                                        mandatory={false}
                                        valueField={
                                            <TextBox
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "input-group"}}
                                                placeholder="Telephone"
                                                property={"Telephone"}
                                                value={details["Telephone"]}
                                                onValueChanged={valueChangeHandler}
                                            />}
                                    ></RetroFormItem>
                                </div>
                                {/*Email*/}
                                <div className="col-sm-12 col-md-4">
                                    <RetroFormItem
                                        label={"Email"}
                                        mandatory={false}
                                        valueField={
                                            <TextBox
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "input-group"}}
                                                placeholder="Email"
                                                property={"Email"}
                                                value={details["Email"]}
                                                onValueChanged={valueChangeHandler}
                                            />}
                                    ></RetroFormItem>
                                </div>
                            </div>
                        </div>
                    </ValidationGroup>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="pt-2">
            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                    onClick={saveData}>
                Save
            </Button>
            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                    onClick={modalClose}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>)
}

export default ManageOwnerVendorAgentDetails;